import { currentProductPrice } from "./currentProductPrice";

export default async function getCartItemPriceData(listingData) {
  const { finalPrice, listing_price, priceType } = await currentProductPrice(listingData);

  return {
    final_price: parseFloat(parseFloat(finalPrice).toFixed(2)),
    listing_sale_price: listingData.listing_sale_price,
    sooperdeal_price: listingData.sooperdeal_price,
    price: {
      finalPrice,
      listing_price,
      priceType,
    }
  }

}
